// dependencies
import { fromJS } from "immutable";

export const FeedbackTypes = {
	everyone: {
		label: "Recognition",
		shareDescription: "Recognition shared with entire company",
	},

	subject: {
		label: "Feedback",
		shareDescription: "Feedback shared with the subject",
	},

	"subject-+-manager": {
		label: "Feedback",
		shareDescription: "Shared with subject and their manager",
	},

	"subject-manager": {
		label: "Feedback",
		shareDescription: "Shared with subject's manager",
	},

	me: {
		label: "Note",
		shareDescription: "Not Shared",
	},
};

export default fromJS(FeedbackTypes);
